import { NewIamHelper } from '../../shared/components/helpers';

(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeePasswordResetController', Controller);

    Controller.$inject = ['$scope', '$state', '$modal', '$translate', 'employeeProfileService', 'passwordResetInfos'];

    function Controller($scope, $state, $modal, $translate, employeeProfileService, passwordResetInfos) {
        $scope.passwordResetInfos = passwordResetInfos;
        $scope.ctxtReset = {};

        $translate('iam.employee.passwordReset.pageTitle').then(function(translation) {
            $scope.updateTopBar(translation, 'fa fa-life-ring');
        });

        $scope.changeOnPasswordReset = function () {
            $scope.ctxtReset.isChecked = false;
            $scope.ctxtReset.isGoodAccessNumber = false;
        }
        $scope.changeOnPasswordReset();

        $scope.checkAccessNumber = function () {
            employeeProfileService.checkAccessCardNumber(this.passwordResetInfos.Employee.EmployeeID, this.iamAccessCardNb)
            .then(function (isOk) {
                $scope.ctxtReset.isChecked = true;
                $scope.ctxtReset.isGoodAccessNumber = eval(isOk);
            });
        }

        $scope.confirmPasswordReset = function () {
            employeeProfileService.confirmPasswordReset(this.passwordResetInfos.Employee.EmployeeID, this.selectedSystem)
            .then(function () {
                NewIamHelper.navigateTo('profile.employee');
            });
        }

        $scope.selectSystem = function () {

            // Modal to select system
            var modalScope = $scope.$new(true);
            modalScope.additionalSystems = $scope.passwordResetInfos.AdditionalSystems;
            modalScope.systems = $scope.passwordResetInfos.Systems;

            var selectSystemModal = $modal({
                scope: modalScope,
                template: require('./passwordReset_SelectSystemModal.tpl.html'),
                placement: 'center'
            });

            modalScope.hideModal = function () {
                selectSystemModal.$promise.then(selectSystemModal.hide);
            }

            modalScope.okModal = function () {
                modalScope.hideModal();
            }

            // Add the selected system
            modalScope.selectSystem = function (selectedSystem) {
                $scope.selectedSystem = selectedSystem;
                modalScope.hideModal();
            }
        }

        // Show Mobile Phones?
        $scope.showMobilePhones = function () {
            if ($scope.passwordResetInfos.Employee.IamMobilePhone) return true;

            return _.size($scope.passwordResetInfos.Employee.EmployeeSecondaryLocations);
        };
    }
})();
